/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-wrap-multilines */
import { Tooltip } from 'antd';
import IconSummary from 'Assets/icons/summary.svg';
import IconMenu from 'Assets/images/commons/menu.svg';
import Close from 'Assets/images/pages/web-chat/close.svg';
import Full from 'Assets/images/pages/web-chat/full.svg';
import Mini from 'Assets/images/pages/web-chat/mini.svg';
import Minimize from 'Assets/images/pages/web-chat/minimize.svg';
import {
  CONSULT_ACCEPTED,
  CONSULT_PENDING,
  CONSULT_TYPE_FOLLOW_UP,
  CONTEXT_MENU_CONSULT_OPTIONS,
  CONTEXT_MENU_CONSULT_SUMMARY,
  POOL_REQUESTS_TAB_ID,
} from 'Constants/consults';
import { CONSULT_DETAILS_FINISH_CONSULT_MODEL_RESPONSE } from 'Constants/webchat';
import useActiveClinicTab from 'Containers/Teleconsult/hooks/useActiveClinicTab';
import { isDurationTooShort, showModalConsultTooShort } from 'Containers/Teleconsult/Main/helpers';
import { generateIncludeParams } from 'Helpers/utils';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { ReactSVG } from 'react-svg';
import { addModal, removeModal } from 'Redux/modules/modal/actions';
import { bubblesAdd, bubblesRemove, bubblesToMinimum } from 'Redux/modules/webChat/commons/actions';
import useProfile from 'Hooks/doctor/useDoctorProfile';
import {
  clearConversationActive,
  conversationActive as conversationActiveAction,
} from 'Redux/modules/webChat/conversationActive/actions';
import { Button, Image, Popup } from 'semantic-ui-react';

import {
  closeAllConsultVideoRoom,
  closeAllContextMenu,
  closeVideo,
  consultDetails,
  consultFinish,
  getOngoingCall,
  resetConsultStatus,
  selectConsultPending,
  setCurrentActiveTab,
  setJumpMessage,
} from '../../../../../redux/modules/webChat/actions';
import { getConsultById } from '../../../../../selectors/webChat/consults';
import { OnGoingCallContent } from '../../FinishConsult/ModalConsultChat';

import styles from './MenuOptions.less';

const consultDetailsResponseParams = {
  include: generateIncludeParams(CONSULT_DETAILS_FINISH_CONSULT_MODEL_RESPONSE),
};

const MenuOptions = props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { profile } = useProfile();
  const {
    changeContextMenu,
    consult,
    consultId,
    consultStatus,
    doctor: { id: doctorId },
    openFinishConsult,
    isMinimize,
    conversationActive,
    onCloseContextMenu,
    activeTab,
    pendingConsultActive,
  } = props;
  const video = useSelector(state => state.webChat.video);
  const videoId = video?.zoomInfo?.id;

  const profileId = profile?.id;

  // disable action when conversation is updating by this doctor
  const consultIsUpdating =
    conversationActive?.isUpdating && conversationActive?.updatedBy === profileId;

  const { id: currentDrId } = useSelector(state => state.webChat.doctor.data);
  const { activeClinicTab } = useActiveClinicTab();

  const pendingConsultActiveObject = useSelector(state =>
    getConsultById(state, pendingConsultActive),
  );

  const { consultType } = consult || pendingConsultActiveObject || {};

  const isFollowUp = consultType === CONSULT_TYPE_FOLLOW_UP;
  const onClickOption = (type, data) => changeContextMenu(type, data);

  const isMainDoctor = currentDrId === consult?.doctor?.id;

  const isDisableAction = activeClinicTab === POOL_REQUESTS_TAB_ID || consultIsUpdating;

  const showBtnFinish = isMainDoctor && consultStatus === CONSULT_ACCEPTED && !isDisableAction;
  const isConsultPending = consultStatus === CONSULT_PENDING;

  const finishConsult = async () => {
    try {
      await dispatch(consultFinish(doctorId, consultId));
    } catch (error) {
      if (error?.data?.errorCode === 'EXIST_ONGOING_VIDEO_CALL') {
        dispatch(
          addModal({
            type: 'warningModal',
            id: 1,
            data: {
              content: (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{ fontSize: '24px', fontWeight: 'bold' }}>Warning</div>
                  <div style={{ padding: '24px', textAlign: 'center' }}>{error?.data?.message}</div>
                </div>
              ),
              size: 'tiny',
              onOk: () => {
                dispatch(resetConsultStatus());
              },
            },
          }),
        );
      }
    }
  };

  const openFinishConsultPopup = async () => {
    if (isFollowUp) {
      openFinishConsult();
      return;
    }

    const consultDetail = await dispatch(consultDetails(consultId, consultDetailsResponseParams));
    const consultDetailData = consultDetail?.data;
    const videoCallDuration = consultDetailData?.videoCallDuration;
    const patientMessageCount = consultDetailData?.patientMessageCount;

    // Warning if the consult is too short
    if (patientMessageCount === 0 && videoCallDuration === 0) {
      await finishConsult();
    } else if (isDurationTooShort(videoCallDuration)) {
      dispatch(showModalConsultTooShort({ handleOnOk: openFinishConsult }));
    } else {
      await openFinishConsult();
    }
  };

  const onFinishConsult = async ongoingCall => {
    const ongoingCallArray = ongoingCall?.data ?? [];
    if (ongoingCall) {
      await dispatch(closeAllConsultVideoRoom(ongoingCallArray?.[0]?.consultId));
      await openFinishConsultPopup();
      if (ongoingCallArray?.map(e => e.id)?.includes(videoId)) {
        dispatch(closeVideo());
      }
    } else {
      await openFinishConsultPopup();
    }
  };

  const handleClickFinishConsult = async () => {
    const ongoingCall = await dispatch(getOngoingCall(consultId));
    const { data: ongoingCallList } = ongoingCall;
    if (ongoingCallList?.length > 0) {
      dispatch(
        addModal({
          type: 'commonModal',
          id: 6,
          data: {
            title: 'On-going Call in Teleconsult',
            content: <OnGoingCallContent />,
            size: 'tiny',
            okButton: (
              <Button
                negative
                onClick={async () => {
                  dispatch(removeModal(6));
                  await onFinishConsult(ongoingCall);
                }}>
                Force End Call
              </Button>
            ),
          },
        }),
      );
    } else {
      await onFinishConsult();
    }
  };

  const handleToBubbleChat = async () => {
    await dispatch(setJumpMessage(null));
    onCloseContextMenu();
    dispatch(closeAllContextMenu());
    dispatch(bubblesAdd(conversationActive));
    dispatch(setCurrentActiveTab(activeTab, conversationActive.id));
    dispatch(clearConversationActive());
  };

  const handleCloseBubbleChat = () => {
    dispatch(bubblesRemove(conversationActive.id));
  };

  const handleToMinimum = async () => {
    dispatch(bubblesToMinimum(conversationActive.id));
  };

  const handleToMax = async () => {
    await setJumpMessage(null);
    dispatch(conversationActiveAction(conversationActive.id, true));
    dispatch(bubblesRemove(conversationActive.id));
    dispatch(setCurrentActiveTab(activeTab, conversationActive.id));
    dispatch(selectConsultPending(-1));
    history.push(`/web-chat/${conversationActive.clinicId || ''}`);
  };

  return isMinimize ? (
    <div className={styles.bubbleChatAction}>
      {!isConsultPending && (
        <Popup
          content="Minimize"
          inverted
          size="mini"
          trigger={
            <Button onClick={handleToMinimum}>
              <ReactSVG className={styles.iconBtnMini} src={Minimize} alt="Minimize" />
            </Button>
          }
        />
      )}
      <Popup
        content="Expand"
        inverted
        size="mini"
        trigger={
          <Button onClick={handleToMax}>
            <ReactSVG className={styles.iconBtn} src={Full} alt="Full" />
          </Button>
        }
      />
      <Popup
        content="Close"
        inverted
        size="mini"
        trigger={
          <Button onClick={handleCloseBubbleChat}>
            <ReactSVG className={styles.iconBtnClose} src={Close} alt="Close" />
          </Button>
        }
      />
    </div>
  ) : (
    <div
      className="menu-options-items"
      style={{ flex: showBtnFinish ? '0 0 300px' : '0 0 150px', justifyContent: 'end' }}>
      {showBtnFinish && (
        <Button
          primary
          onClick={handleClickFinishConsult}
          content="Finish Consult"
          style={{ backgroundColor: '#30a1f9', borderRadius: '8px' }}
          className={styles.finishButton}
        />
      )}
      {!isDisableAction && (
        <div className={styles.toMini}>
          <Tooltip title="Minimize" placement="bottom">
            <Button onClick={handleToBubbleChat} disabled={pendingConsultActive !== -1}>
              <Image src={Mini} alt="mini" />
            </Button>
          </Tooltip>
        </div>
      )}
      {!isDisableAction && !isConsultPending && (
        <div className={styles.toMini}>
          <Tooltip title="Consult Summary" placement="bottom">
            <Button
              onClick={() => onClickOption(CONTEXT_MENU_CONSULT_SUMMARY, { consultId })}
              disabled={pendingConsultActive !== -1}>
              <Image src={IconSummary} alt="mini" />
            </Button>
          </Tooltip>
        </div>
      )}
      {!isDisableAction && !isConsultPending && (
        <div className={styles.toMini}>
          <Tooltip title="Consult Menu" placement="bottom">
            <Button
              onClick={() => onClickOption(CONTEXT_MENU_CONSULT_OPTIONS, { consultId })}
              disabled={pendingConsultActive !== -1}>
              <Image src={IconMenu} alt="mini" />
            </Button>
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default MenuOptions;
